/**
 * Modal Component
 */
(function () {
  "use strict";

  const Modal = {
    init() {
      const modalTriggers = document.querySelectorAll("[data-modal-open]");
      const modalCloses = document.querySelectorAll("[data-modal-close]");

      modalTriggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          const modalId = trigger.dataset.modalOpen;
          const modal = document.querySelector(`[data-modal="${modalId}"]`);
          if (modal) {
            modal.classList.add("open");
            document.body.style.overflow = "hidden";
          }
        });
      });

      modalCloses.forEach((close) => {
        close.addEventListener("click", () => {
          const modal = close.closest("[data-modal]");
          if (modal) {
            modal.classList.remove("open");
            document.body.style.overflow = "";
          }
        });
      });

      // Close on overlay click
      document.querySelectorAll("[data-modal-overlay]").forEach((overlay) => {
        overlay.addEventListener("click", (e) => {
          if (e.target === overlay) {
            const modal = overlay.closest("[data-modal]");
            if (modal) {
              modal.classList.remove("open");
              document.body.style.overflow = "";
            }
          }
        });
      });

      // Close on ESC key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          const openModal = document.querySelector("[data-modal].open");
          if (openModal) {
            openModal.classList.remove("open");
            document.body.style.overflow = "";
          }
        }
      });
    },
  };

  window.Modal = Modal;
})();

